import { render, staticRenderFns } from "./TheoryPracticeWorkshopSignupSuccess.vue?vue&type=template&id=cb4b6f64&scoped=true&"
import script from "./TheoryPracticeWorkshopSignupSuccess.vue?vue&type=script&lang=js&"
export * from "./TheoryPracticeWorkshopSignupSuccess.vue?vue&type=script&lang=js&"
import style0 from "./TheoryPracticeWorkshopSignupSuccess.vue?vue&type=style&index=0&id=cb4b6f64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4b6f64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
